<!-- =========================================================================================
    File Name: VxBreadcrumb.vue
    Description: Breadcrumb component
    Component Name: VxBreadcrumb
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="vx-breadcrumb hidden md:block">
    <ul class="flex flex-wrap items-center">
      <li class="inline-flex items-end">
        <router-link to="/">
          <feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 stroke-current text-primary" />
        </router-link>
        <span class="breadcrumb-separator mx-2"><feather-icon :icon="isRTL ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svgClasses="w-4 h-4" /></span>
      </li>
      <li v-for="(link, index) in breadcrumb.slice(1, -1)" :key="index" class="inline-flex items-center">
        <router-link :to="link.url" v-if="link.url">{{ $t(link.title) }}</router-link>
        <span class="text-primary cursor-default" v-else>{{ $t(link.title) }}</span>
        <span class="breadcrumb-separator mx-2 flex items-start"><feather-icon :icon="isRTL ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svgClasses="w-4 h-4" /></span>
      </li>
      <li class="inline-flex">
        <span v-if="breadcrumb.slice(-1)[0] && breadcrumb.slice(-1)[0].active" class="cursor-default">{{ $t(breadcrumb.slice(-1)[0].title) }} </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "vx-breadcrumb",
  props: {
    breadcrumb: {
      type: Array,
      required: true
    },
    isRTL: {
      type: Boolean,
      default: false
    }
  }
};
</script>
